export const truncateText = (text: string, truncateLength: number) => {
	return `${text.slice(0, truncateLength)}…${truncateLength > 0 ? text.slice(-truncateLength) : ''}`;
};
